import React from 'react';
import { Config } from '@leverege/plugin';
import { BlueprintDataSource } from '@leverege/molten-core';
import ParentSelector from "./ParentSelector.js";
import ParentUtil from "./ParentUtil.js";
import { jsx as _jsx } from "react/jsx-runtime";
const EMPTY = {};
const opts = {
  table: {
    isRenderer: true,
    blockChildren: false
  },
  detail: {
    isRenderer: true,
    blockChildren: false
  }
};
export default {
  valueType: 'parentRelationship',
  getOptions: usage => {
    return Config.get('ParentRelationshipEditor', usage, opts[usage]);
  },
  create: opts => {
    const {
      usage,
      attribute,
      object,
      onChange,
      value,
      title,
      editable,
      eventData,
      children,
      variant,
      style
    } = opts;
    const {
      relationship
    } = BlueprintDataSource.getRelationship(object) || EMPTY;
    const parentAction = ParentUtil.getParentAction(object, attribute);
    return parentAction == null || !value && !editable ? children : /*#__PURE__*/_jsx(ParentSelector, {
      style: style,
      textVariant: variant,
      editable: editable,
      usage: usage,
      attribute: attribute,
      onChange: onChange,
      parentAction: parentAction,
      relationship: relationship,
      eventData: eventData,
      value: value,
      title: title,
      showFilter: true
    });
  }
};